<template>
  <v-container class="two-column-layout" fluid>
    <v-layout wrap align-center justify-center row fill-height>
      <v-flex class="left-column hidden-xs-only" align-self-center sm5>
        <img class="logo" :src="require('@/assets/logo_white_240x68.png')" />
        <img
          class="illustration"
          :src="require('./img/left_column_illustration.svg')"
        />
      </v-flex>
      <v-flex xs12 sm7 align-self-center class="right-column">
        <v-layout column align-self-center>
          <div class="hidden-sm-and-up">
            <img class="logo" :src="require('@/assets/logo_accent.png')" />
          </div>
          <transition name="fade">
            <router-view></router-view>
          </transition>
        </v-layout>
      </v-flex>
    </v-layout>
    <GlobalNotifications></GlobalNotifications>
  </v-container>
</template>

<script>
import GlobalNotifications from '@/components/GlobalNotifications'

export default {
  components: {
    GlobalNotifications
  }
}
</script>

<style lang="stylus">
.two-column-layout {
    padding: 0 !important
    height: 100%

    .left-column {
        background: var(--v-primary-base);
        background: linear-gradient(0deg, #35e267 0%, var(--v-primary-base) 100%);
        height 100%
        display flex
        flex-direction column
        justify-content center
        align-items center

        img.logo {
            margin-bottom 10%
            height: 28px
        }

        img.illustration {
            max-height 80%
            max-width 80%
        }
    }

    .right-column {
        text-align center
        position relative
        min-height: 100%;
        display: flex;

        .logo {
            height 50px
        }

    }
}
</style>
